<template>
    <el-container direction="vertical" style="min-width: 1024px;">
        <Header />
        <el-container>
            <slot />
        </el-container>
    </el-container>
</template>

<script>
import Header from './header';

export default {
    components: { Header },
};
</script>
